(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "685918c41cd2062d4600ce92";
              window.beaePageSetting.pageTitle = "Spotlights"; 
              window.beaePageSetting.pageType = "section";

          let js_6PRIP15M = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-vn2ryi9csection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vn2ryi9c',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vn2ryi9c');
        args.el = args.els[0];
        ((data) => { var t;if((t=data.el.querySelector(".beae-grid-system"))==null||t.addEventListener("scroll",o=>{var r,n;let a=o.target;if(!a.classList.contains("beae-grid-carousel"))return;let s=Math.round((a.scrollLeft+a.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(a.offsetWidth*.8))+1;(r=data.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(n=data.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||n.classList.add("active")}),data.mode.value=="live"){const videoContainer=data.el.querySelector('.beae-section-background-video[data-device="desktop"]'),videoMobileContainer=data.el.querySelector('.beae-section-background-video[data-device="mobile"]'),initVideoBackground=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(videoContainer){let options={};if(data.optionsVideo)try{eval("options = "+data.optionsVideo)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoContainer);rs&&(videoContainer.innerHTML=rs.html,initVideoBackground.push("desktop"))}}else if(videoMobileContainer){let options={};if(data.optionsVideoMobile)try{eval("options = "+data.optionsVideoMobile)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoMobileContainer);rs&&(videoMobileContainer.innerHTML=rs.html,initVideoBackground.push("mobile"))}}(videoContainer||videoMobileContainer)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!initVideoBackground.includes("desktop")&&window.innerWidth>=768&&videoContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo,videoContainer);o&&(videoContainer.innerHTML=o.html,initVideoBackground.push("desktop"))}if(!initVideoBackground.includes("mobile")&&window.innerWidth<768&&videoMobileContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile,videoMobileContainer);o&&(videoMobileContainer.innerHTML=o.html,initVideoBackground.push("mobile"))}}})}data.el.querySelectorAll(".beae-text-highlight").forEach(o=>{new IntersectionObserver((s,r)=>{s.forEach(n=>{n.isIntersecting&&(n.target.querySelectorAll("path, line").forEach(l=>{l.style.strokeDasharray=parseFloat(l.getAttribute("data-dash-ratio")*n.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(n.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(o)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vn2ryi9c: ', ex)
      };
    

      try {
        let argid = 'beae-vn2ryi9csection-featured-collection',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vn2ryi9c',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vn2ryi9c');
        args.el = args.els[0];
        ((a) => { window.BeaeSlideshow&&window.BeaeSlideshow.init(a) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vn2ryi9c: ', ex)
      };
    

      try {
        let argid = 'beae-vn2ryi9csection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vn2ryi9c',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vn2ryi9c');
        args.el = args.els[0];
        ((m) => { window.BeaeSlider&&!m.noRunJs&&window.BeaeSlider(m) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vn2ryi9c: ', ex)
      };
    

      try {
        let argid = 'beae-0xqajk2rblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-0xqajk2r',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-0xqajk2r');
        args.el = args.els[0];
        ((v) => { if(v.el){let x,C=v.autoHover;var b=v.el.querySelector(".beae-img-ratio-control"),y=v.el.querySelector(".beae-img-comp-container"),_=v.el.querySelector(".beae-img-comp-container--second");if(b&&_){let h=function(k){let w=0,S,$,B;L(),C?v.el.onmouseover=function(E){V(E)}:k.onmousedown=function(E){V(E)},v.el.onmouseup=function(){M()},k.ontouchstart=function(E){V(E)},v.el.ontouchend=function(){M()};function L(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{x=_.offsetWidth})}).observe(_),k.style.left&&($=parseInt(k.style.left))}function V(E){check=!1,E.preventDefault(),E.clientX?S=E.clientX:S=E.touches[0].clientX,w=1,v.el.onmousemove=function(P){T(P)},v.el.ontouchmove=function(P){T(P)}}function M(){w=0,isNaN(B)||($=B),check=!0}function T(E){if(w==0||C&&!(E.target==_||E.target==v.el.querySelector(".beae-image-secondary")))return!1;B=N(E),B<0&&(B=0),B>100&&(B=100),O(B)}function N(E){E=E.changedTouches?E.changedTouches[0]:E;let P;return C?P=Math.round(E.offsetX*100/x):P=Math.round($-(S-E.pageX)*100/x),P}function O(E){k.style.left=E+"%",_.style.clipPath=`polygon(${E}% 0%, ${E}% 100%, 100% 100%, 100% 0)`,y.style.clipPath=`polygon(0% 100%, 0% 0%, ${E}% 0%, ${E}% 100%)`}};b&&_&&h(b),window.addEventListener("resize",function(){b&&_&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{x=_.offsetWidth})}).observe(_),h(b))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-0xqajk2r: ', ex)
      };
    }; if (window.BEAEBASE) {js_6PRIP15M()} else {window.BEAEPAGEJS.push(js_6PRIP15M)} })(); 